"use client";

import { Animated } from "../animated";
import { Hero } from "./hero";
import { Mission } from "./mission";
import { Problem } from "./problem";
import { Approach } from "./approach";
import { HowItWorks } from "./how-it-works";
import { Capabilities } from "./capabilities";
import { Sectors } from "./sectors";
import { Terrakio } from "./terrakio";
import { TechnologyInAction } from "./technology-in-action";
import { Results } from "./results";
import { ScientificRigour } from "./scientific-rigour";
import { People } from "./people";
import { HowWeWork } from "./how-we-work";
import { Contact } from "./contact";

export const HomePage = () => (
  <Animated>
    <main className="dc-page bg-ink">
      <Hero />
      <Mission />
      <Problem />
      <Approach />
      <HowItWorks />
      <Capabilities />
      <Sectors />
      <Terrakio />
      <TechnologyInAction />
      <Results />
      <ScientificRigour />
      <People />
      <HowWeWork />
      <Contact />
    </main>
  </Animated>
);
